export default "__VITE_ASSET__B$7eT6WI__"